import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import theme from "../../theme";
import Label from "../Label";
import f from "../../resources/functions";
import useForceUpdate from 'use-force-update';
/* VALID : 0 MEANS INVALID, 1 MEANS VALID, -1 MEANS DEFAULT */

const InputComponent = styled.input `
    background-color: ${ props => (props.bgColor || theme.inputs.bgColor ) };
    padding: ${ props => (props.padding || theme.inputs.padding ) };
    border-radius:  ${ props => (props.borderRadius || theme.inputs.borderRadius) };
    margin-right:  ${ props => (props.marginRight || 0) };
    box-sizing: content-box;
`;



const Input = (props) => {
    const [state, setState] = useState({ isValid: -1, value: "" });
    const update = useForceUpdate();
    const { contentType, valid, getSetValue, textTransform, customValidation, width, name, type, containerStyle, vPadding, textColor, getOnChange, onChange, label, minWidth, style } = props


    useEffect(() => {
        if (getSetValue) {
            getSetValue(setValue);
        } 
    });


    const handleChange = event => {
        console.log("changing : ",event);
        if (onChange) onChange(event.target.value);
        console.log("event.target.value : ",event.target.value);
        setState({value:event.target.value});
        update();
        console.log("value : ",state.value);
        if (customValidation) {
            if (customValidation(event.target.value) === 1) {
                setState(state => ({ ...state, isValid: 1 }));
                if(getOnChange) getOnChange({isValid: 1,val: state.value,name});
            } else {
                setState(state => ({ ...state, isValid: -1 }));
                if(getOnChange) getOnChange({isValid: -1,val: state.value,name});
            }
        }
        else if (contentType) {
            if (f.validateField(state.value,contentType) === 1) {
                setState(state => ({ ...state, isValid: 1 }));
                if(getOnChange) getOnChange({isValid: 1,val: state.value,name});
            } else {
                setState(state => ({ ...state, isValid: -1 }));
                if(getOnChange) getOnChange({isValid: -1,val: state.value,name});
            }
            update();
            
        }
        

    }


    const handleOnBlur = (event) => {
        console.log(" event.target.value before : ", event.target.value);
        event.target.value =  f.formatField(event.target.value,contentType);
       console.log(" event.target.value : ", event.target.value);
       setState({value:event.target.value});
        var isValid = -1;
        if (customValidation) {
            isValid = customValidation(event.target.value);
            console.log("isValid : ",isValid);
            setState(state => ({ ...state, isValid  }));
            update();
        }
        else if (contentType) {
            isValid = f.validateField(event.target.value,contentType);
            setState(state => ({ ...state, isValid  }));
            update();
        }
        if(getOnChange) getOnChange({isValid: isValid,val: event.target.value, name});
    }

    const setValue = (val) => {
        console.log("setting valueeee : ",val);
        setState({value:val});
        update();
    }

    return (
        <div style={{paddingTop:vPadding || null,paddingBottom:vPadding || null,...containerStyle}}>
            {label ? <Label for={name}>{label}</Label> : null}
            <InputComponent 
                {...props}
                name={name}
                type={type || "text"}
                value={state.value}
                style={{
                    color: textColor || theme.colors.text,
                    minWidth: minWidth,
                    width: width,
                    textTransform: textTransform || "none",
                    boxShadow: state.isValid === 0 || valid === 0 ? "inset 0px 0px 0px 2px "+theme.colors.error : (state.isValid === 1 || valid === 1 ? "inset 0px 0px 0px 2px "+theme.colors.success : "none"),
                    ...style
                }} 
                onBlur={event => {handleOnBlur(event)}}
                {...(!props.noOnChange && { onChange: event => {handleChange(event)} } )}
            />
        </div>
    );
};



export default Input;